import React from 'react';
import cx from 'classnames';
import { FGIcons } from '@fg/design-system';

interface IExternalDataItemProps {
    name: string;
    id: number;
    checked: boolean;
    selectedList: number[];
    onclick: (id: number) => any;
}

class ExternalDataItem extends React.Component<IExternalDataItemProps> {
    public render() {
        return (
            <div
                className={cx('external-data-item', {
                    checked: this.props.checked,
                })}
                onClick={() => this.props.onclick(this.props.id)}>
                {this.props.checked && (
                    <FGIcons
                        icon="LeftArrow"
                    />
                )}
                <span>{this.props.name}</span>
                {!this.props.checked && <FGIcons icon="RightArrow" />}
            </div>
        );
    }
}

export default ExternalDataItem;
